import * as actionTypes from './actionType';

export const getEventsForRange = (id, startDate, endDate) => ({
    type: actionTypes.GET_EVENTS_BY_DAY,
    id,
    startDate,
    endDate,
    isLoading: true,
});
